// extracted by mini-css-extract-plugin
export default {"wrapper":"Step9_wrapper__d7x4d","help":"Step9_help__XcpHj","noBankIdLink":"Step9_noBankIdLink__VvPwo","popup":"Step9_popup__pQrwr","loading":"Step9_loading__OdzZj"};